import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

export const CommonOperatorCrumbs: Array<BreadcrumbItem> = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Operatori',
    path: '/sistema/operatori',
  },
];
